import styled from 'styled-components';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import ButtonListToggler from 'components/base/ButtonListToggler';
import LineLoader from '../../../Forecasting/ProjectProgression/ProgressionTable/Header/LineLoader';
import useResourceTypesGroupOptions from './useResourceTypeGroupOptions';

const StyledResourceTypeToggler = styled.div`
  display: flex;
`;

const ResourceTypeToggler = ({ resourceType, onChange }) => {
  const { groupsList, isLoading } = useResourceTypesGroupOptions();

  const onResourceTypeChange = currType => {
    onChange(currType);
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.RESOURCE_ALLOCATION,
      click_type:
        TRACKING.CLICK.RESOURCE_ALLOCATION.AGGREGATED_TABLE
          .RESOURCE_TYPE_FILTER,
      value: currType.key
    });
  };

  if (isLoading) return <LineLoader />;

  return (
    <StyledResourceTypeToggler data-cy='resource-type-toggler'>
      {groupsList.map(group => (
        <ButtonListToggler
          key={group.type}
          list={group.options}
          max={group.max}
          value={resourceType?.key}
          onChange={option => onResourceTypeChange(option.resourceType)}
        />
      ))}
    </StyledResourceTypeToggler>
  );
};

export default ResourceTypeToggler;
